import { ref } from 'vue'
import { defineStore } from 'pinia'
import userApi from '@/api/userApi'

export const useBannerStore = defineStore('bannerStore', () => {
  const banners = ref<UserBanner[]>([])
  const loading = ref(false)
  const loadedUserId = ref<number | null>(null)
  let loadGeneration = 0

  const reset = () => {
    loadGeneration++
    banners.value = []
    loadedUserId.value = null
    loading.value = false
  }

  const load = async (userId: number | null | undefined) => {
    if (!userId) {
      reset()
      return
    }

    if (loadedUserId.value === userId || loading.value) return

    const generation = loadGeneration
    loading.value = true

    try {
      const response = await userApi.getBanners()
      if (generation === loadGeneration) {
        banners.value = response.data
        loadedUserId.value = userId
      }
    } catch {
      if (generation === loadGeneration) {
        banners.value = []
        loadedUserId.value = userId
      }
    } finally {
      if (generation === loadGeneration) {
        loading.value = false
      }
    }
  }

  return { banners, loading, load, reset }
})
